//
//
//
//
//
//
//
//
//
//
//
//
//

import md5 from "js-md5";
// const baseURL = process.env.VUE_APP_ENV  === 'prod' ? 'ws://emp.construn.cn/kpush' : 'ws://192.168.0.118:1097/kpush.io';
var baseURL = process.env.VUE_APP_ENV === 'prod' ? 'wss://vehicle.construn.cn:/kpush' : 'wss://test-vehicle.construn.cn/kpush';
export default {
  data: function data() {
    return {
      conversations: {},
      JIM: null,
      websocket: null,
      existOrderTip: false,
      existExpressTip: false,
      reconnectAttempts: 0,
      // 计数重连次数
      maxReconnectInterval: 300 * 1000,
      // 最大重连间隔，五分钟
      kPushKey: null
    };
  },
  props: {},
  mounted: function mounted() {
    var vm = this;
    setTimeout(function () {
      vm.getUnreadMsgCnt();
    }, 2000);
    this.initWebsocket();
  },
  methods: {
    initWebsocket: function initWebsocket() {
      var _this = this;
      // Avoid creating a new WebSocket if one already exists and is open or connecting
      if (this.websocket && (this.websocket.readyState === WebSocket.OPEN || this.websocket.readyState === WebSocket.CONNECTING)) {
        return;
      }
      var vm = this;
      this.websocket = new WebSocket(baseURL);
      this.websocket.onopen = function () {
        vm.reconnectAttempts = 0; // 重置重连次数
      };
      this.websocket.onmessage = function (event) {
        var msg = JSON.parse(event.data);
        switch (msg.code) {
          case "0":
            if (msg.messageType == "AUTH") {
              // Send heartbeat data
              console.log(JSON.parse(sessionStorage.getItem("data")).userId);
              var u = {
                "messageType": "AUTH",
                "auth": {
                  "userId": JSON.parse(sessionStorage.getItem("data")).userId,
                  "source": "SEVEN",
                  "channelType": "WEB"
                }
              };
              // WebSocket is connected, send data
              console.log("sssss");
              _this.websocket.send(JSON.stringify(u));
            }
            if (msg.messageType == "AUTH_SUCCESS") {
              //认证成功
              _this.kPushKey = msg.obj;
            }
            if (msg.messageType == "MESSAGE") {
              setTimeout(function () {
                vm.getUnreadMsgCnt();
              }, 2000);
              vm.existOrderTip = true;
              vm.$notify.info({
                title: "新消息",
                message: "您有新的消息，请及时处理！",
                position: "bottom-right",
                onClose: function onClose() {
                  vm.existExpressTip = false;
                }
              });
              setTimeout(function () {
                vm.playOrderAudio();
              }, 1000);
            }
            break;
          case "1":
            if (msg.messageType == "DISCONNECTED") {
              vm.scheduleReconnect();
            }
            if (msg.messageType == "ERROR") {
              //服务端错误
            }
            break;
        }
      };
      this.websocket.onclose = function () {
        console.log("WebSocket connection closed");
        vm.scheduleReconnect();
      };
      this.websocket.onerror = function (error) {
        console.log("WebSocket error observed:", error);
        vm.scheduleReconnect();
      };
    },
    scheduleReconnect: function scheduleReconnect() {
      var vm = this;
      var reconnectInterval = Math.min(Math.pow(2, vm.reconnectAttempts) * 1000, vm.maxReconnectInterval);
      console.log("Reconnecting in ".concat(reconnectInterval / 1000, " seconds..."));
      setTimeout(function () {
        vm.reconnectAttempts++;
        vm.initWebsocket();
      }, reconnectInterval);
    },
    //播放音频
    playOrderAudio: function playOrderAudio() {
      setTimeout(function () {
        var audio = document.getElementById("orderAudios");
        audio.currentTime = 0;
        audio.play();
      }, 500);
    }
  }
};